import type { CSSProperties } from "react";

// Shared recharts <Tooltip> styling — keeps every chart tooltip visually
// consistent. Override individual fields at the call site when needed, e.g.
// contentStyle={{ ...chartTooltipContentStyle, fontSize: 12 }}.
export const chartTooltipContentStyle: CSSProperties = {
  background: "var(--card)",
  border: "1px solid var(--border)",
  borderRadius: 8,
  fontSize: 11,
};

export const chartTooltipLabelStyle: CSSProperties = {
  color: "var(--foreground)",
  marginBottom: 4,
};

// Shared hour:minute formatter for schedule-style charts (fi-FI, 24h clock).
export function formatChartHour(iso: string): string {
  return new Date(iso).toLocaleTimeString("fi-FI", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
